import styled from '@emotion/styled';
import { useFlag } from '@innovamat/flags';
import { useUser } from '@innovamat/ga-features';
import { IconButton, Typography } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  hasClassroomDigitalPracticeAccess: boolean;
  handleOpenDigitalPracticeAccessModal: () => void;
  handleOpenDigitalAccessConfirmationModal: () => void;
};

function DigitalPracticeSublabelContent({
  hasClassroomDigitalPracticeAccess,
  handleOpenDigitalPracticeAccessModal,
  handleOpenDigitalAccessConfirmationModal,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const { user, isRole } = useUser();

  const { value: showConfigHomeAccessOption } = useFlag(
    'showConfigHomeAccessOption',
    false,
    {
      identifier: '',
      custom: {
        region: user?.region ?? '',
      },
    }
  );

  if (isRole.Advisor || showConfigHomeAccessOption) {
    return (
      <Container>
        <IconButton
          icon="SettingsIcon"
          onClick={handleOpenDigitalPracticeAccessModal}
          size="S"
        />
        <span>{t('students.home-access-modal.configure')}</span>
      </Container>
    );
  }

  return (
    <Container>
      <Typography.Link3 onClick={handleOpenDigitalAccessConfirmationModal}>
        {hasClassroomDigitalPracticeAccess
          ? t('students.home-access.configuration.disable')
          : t('students.home-access.configuration.enable')}
      </Typography.Link3>
    </Container>
  );
}

export { DigitalPracticeSublabelContent };
